export enum TrackingIndicatorLineStates {
    UNCOMPLETED = 'UNCOMPLETED',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR',
}
